import React from "react";
import "./TestimonialBubble.css";

type TestimonialBubbleProps = {
  readonly name?: string;
  readonly position: string;
  readonly content: string;
};

function TestimonialBubble({
  name,
  position,
  content,
}: TestimonialBubbleProps) {
  return (
    <div className="testimonial-bubble">
      <div className="speech-bubble">{content}</div>
      <div className="testimonial-meta">
        {name}
        {name && " - "}
        {position}
      </div>
    </div>
  );
}

export default TestimonialBubble;
